import { useMemo, useState, Dispatch, SetStateAction } from 'react';
import { Checkbox, Menu, MenuItem, Typography } from '@mui/material';
import { OperationIncident, updateOperationIncident } from '@networkRequest/operationsService';
import { useUser } from '@hooks/useUser';
import IncidentDetailItem from './IncidentDetailItem';
import { OPERATION_INCIDENT_TYPES } from '../../../../constants';

const IncidentType = ({
  loading = false,
  incident,
  setIncident,
  setError,
}: {
  loading: boolean;
  incident: OperationIncident;
  setIncident: Dispatch<SetStateAction<OperationIncident | null>>;
  setError: Dispatch<SetStateAction<string | null>>;
}) => {
  const { user } = useUser();

  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  const selectedTypes = useMemo(
    () => {
      const incidentTypeStr = incident?.incident_type;
      return incidentTypeStr ? incidentTypeStr.split(',') : [];
    },
    [incident]
  );

  const handleEdit = async (value: string) => {
    if (!user) {
      return;
    }
    const newTypes = selectedTypes.includes(value)
      ? selectedTypes.filter((incident_type) => incident_type !== value)
      : [...selectedTypes, value];

    const { data, error } = await updateOperationIncident({
      accessToken: user.accessToken,
      incidentId: incident.id,
      payload: {
        incident_type: newTypes.join(','),
      }
    });

    if (data) {
      setIncident(data);
    } else {
      setError(error ?? 'Failed to update incident');
    }
  };

  const typeIds = Object.keys(OPERATION_INCIDENT_TYPES);

  const incidentTypeDisplay = selectedTypes.map((incident_type) => OPERATION_INCIDENT_TYPES[incident_type]).join(', ');

  if (!user) return null;

  return (
    <>
      <IncidentDetailItem
        name='Type of Incident'
        onClick={(e: any) => setMenuAnchor(e.currentTarget)}
      >
        <Typography variant='body1'>
          {incidentTypeDisplay.length ? incidentTypeDisplay : '\u00A0'}
        </Typography>
      </IncidentDetailItem>
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {typeIds.map((incident_type) => {
          return (
            <MenuItem key={incident_type} onClick={() => handleEdit(incident_type)} disabled={loading}>
              <Checkbox checked={selectedTypes.includes(incident_type)} />
              {OPERATION_INCIDENT_TYPES[incident_type]}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default IncidentType;